import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";
import SupervisorAccountOutlinedIcon from "@mui/icons-material/SupervisorAccountOutlined";
import StoreOutlinedIcon from "@mui/icons-material/StoreOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import SavingsOutlinedIcon from "@mui/icons-material/SavingsOutlined";
import SpeedOutlinedIcon from "@mui/icons-material/SpeedOutlined";
import CustomizedTimeline from "../components/CustomizedTimeline";
import AccordionComponent from "../components/Accordion";
import LandingAnalyticsSection from "../components/LandingAnalyticsSection";
import LandingProductsSection from "../components/LandingProductsSection";
import LandingProductDetailsSection from "../components/LandingProductDetailsSection";
import LandingCreationSection from "../components/LandingCreationSection";
import LandingMotivationSection from "../components/LandingMotivationSection";
import LandingSectionHeader from "../components/LandingSectionHeader";
import {
  MessengerBrandInline,
  MessengerBrandStack,
} from "../components/MessengerBrandIcons";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import "./index.css";

const AUDIENCE = {
  subtitle: "Платформа будет интересна, если вы:",
  points: [
    {
      icon: <BadgeOutlinedIcon />,
      text: "HR-специалист или HR-директор",
    },
    {
      icon: <SchoolOutlinedIcon />,
      text: "Занимаетесь обучением и развитием сотрудников (L&D)",
    },
    {
      icon: <PersonAddOutlinedIcon />,
      text: "Отвечаете за онбординг и адаптацию новичков",
    },
    {
      icon: <SupervisorAccountOutlinedIcon />,
      text: "Руководитель отдела, который хочет стандартизировать процессы",
    },
    {
      icon: <StoreOutlinedIcon />,
      text: "Владелец или управляющий бизнеса, который инвестирует в команду",
    },
    {
      icon: <StorefrontOutlinedIcon />,
      text: "Работаете в ритейле, HoReCa или сервисе с линейным персоналом",
    },
    {
      icon: <HeadsetMicOutlinedIcon />,
      text: "Руководите отделом продаж или клиентского сервиса",
    },
    {
      icon: <GroupsOutlinedIcon />,
      text: "Наставник или тимлид, который устал отвечать на одни и те же вопросы",
    },
  ],
};

const BENEFITS = [
  {
    icon: <AccountTreeOutlinedIcon />,
    title: "Живое обучение, не запись",
    desc: "Сотрудник принимает решения — и видит разный результат. Это вовлекает сильнее, чем линейное видео, которое перематывают на третьей минуте.",
  },
  {
    icon: <PlayCircleOutlineIcon />,
    title: "Подсказка вместо забытых инструкций",
    desc: "Инструкцию легко забыть — в боте подсказка всегда под рукой. База знаний снимает повторяющиеся вопросы без поиска в чатах и ожидания наставника.",
  },
  {
    icon: <TrendingUpOutlinedIcon />,
    title: "Прокачка навыков и мотивация",
    desc: "Тренажёр отрабатывает знания на практике. Можно поощрять команду: ачивки, рейтинг, бонусы за лучший результат.",
  },
  {
    icon: <GroupsOutlinedIcon />,
    title: "Там, где уже работает команда",
    desc: "Telegram и MAX — без новых приложений, регистраций и долгой настройки LMS.",
  },
  {
    icon: <SavingsOutlinedIcon />,
    title: "Видео и текст в одном месте",
    desc: "Объясняйте как удобно: коротким текстом или видео — формат подбираете вы под каждую задачу.",
  },
];

const OUTCOMES = [
  {
    icon: <SpeedOutlinedIcon />,
    title: "Быстрее адаптация",
    desc: "Новичок проходит программу в своём темпе и быстрее выходит на рабочие задачи.",
  },
  {
    icon: <SavingsOutlinedIcon />,
    title: "Меньше нагрузки на HR",
    desc: "Повторяющиеся вопросы уходят в базу знаний — наставники не отвлекаются на одно и то же.",
  },
  {
    icon: <GroupsOutlinedIcon />,
    title: "Единый стандарт",
    desc: "Одинаковое качество обучения для всей команды, независимо от офиса и наставника.",
  },
];

const STORIES = [
  {
    segment: "Кофейня · HoReCa",
    tool: "База знаний",
    story:
      "На вечерней смене гость сказал, что кофе испорчен. Новый бариста растерялся — открыл бота и за секунду нашёл, как правильно ответить. Смена прошла без эскалации.",
    result:
      "Наставник не успевал бегать между стойками — база знаний закрыла типовые конфликтные ситуации на смене.",
  },
  {
    segment: "Сеть магазинов · ритейл",
    tool: "Сценарий",
    story:
      "Каждый новый продавец проходил одну программу: возврат, касса, работа с жалобами. Руководитель сети наконец получил одинаковое качество сервиса во всех точках.",
    result:
      "Онбординг перестал зависеть от того, кто наставник в конкретном магазине.",
  },
  {
    segment: "Отдел продаж · B2B",
    tool: "Тренажёр",
    story:
      "После обновления линейки продуктов менеджеры прошли тренажёр за вечер. Руководитель сразу увидел, кто готов к встречам, а кому нужна дополнительная сессия.",
    result:
      "Проверка знаний без очных тестов и таблиц в Excel — результат виден сразу.",
  },
  {
    segment: "Служба поддержки",
    tool: "База знаний + Сценарий",
    story:
      "Операторы перестали писать в общий чат «а что ответить клиенту?». Типовые кейсы — в базе знаний, сложные — отработали в сценарии до выхода на линию.",
    result:
      "Нагрузка на тимлида снизилась, время ответа клиенту — тоже.",
  },
  {
    segment: "Склад · производство",
    tool: "Сценарий",
    story:
      "Ввели новое оборудование — похожее на старое, но с другими правилами безопасности. Сценарий помог отработать действия до выхода на смену, включая нестандартные ситуации.",
    result:
      "Меньше ошибок в первые недели после изменений — команда была готова заранее.",
  },
];

export default function MainPage() {
  return (
    <div className="landing landing--pattern">
      <section className="landing-hero landing-hero--mesh">
        <div className="landing-hero__content">
          <p className="landing-hero__badge landing-hero__badge--phrase">
            Обучение, база знаний и тренажёр в твоём кармане
          </p>
          <p className="landing-hero__channels">Доступно в Telegram и MAX</p>
          <div className="landing-hero__messengers">
            <MessengerBrandInline size={34} spaced />
          </div>
          <h1 className="landing-hero__title">MOGAME</h1>
          <p className="landing-hero__subtitle">
            MOGAME помогает команде учиться на практике: интерактивные сценарии,
            карманная база знаний с ответами в видео и тексте, тренажёр для
            прокачки навыков.
          </p>
          <p className="landing-hero__subtitle landing-hero__subtitle--second">
            Всё в привычном мессенджере — без отдельных приложений и сложных
            систем.
          </p>
          <div className="landing-hero__actions">
            <Link to="/login?tab=register">
              <Button
                variant="contained"
                size="large"
                className="landing-hero__btn-primary"
              >
                Начать
              </Button>
            </Link>
            <Link to="/login">
              <Button
                variant="outlined"
                size="large"
                className="landing-hero__btn-secondary"
              >
                Войти
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <LandingProductsSection />

      <LandingProductDetailsSection />

      <section
        id="audience"
        className="landing-band landing-band--audience landing-section landing-section--audience"
      >
        <div className="landing-container">
          <LandingSectionHeader
            label="03 · Для кого"
            title="Кому подходит MOGAME"
            desc="HR и руководителям, которые хотят обучать сотрудников, развивать навыки и давать команде удобный инструмент — без сложных систем и лишней бюрократии."
          />
          <div className="landing-band__panel landing-band__panel--audience">
            <div className="landing-audience landing-audience--single">
              <article className="landing-audience-card">
                <div className="landing-audience-card__messengers">
                  <MessengerBrandInline size={30} />
                  <span>Обучение, развитие и подсказки — там, где уже общается команда</span>
                </div>
                <p className="landing-audience-card__subtitle">{AUDIENCE.subtitle}</p>
                <div className="landing-audience-roles">
                  {AUDIENCE.points.map(({ icon, text }) => (
                    <article className="landing-audience-role" key={text}>
                      <div className="landing-audience-role__icon">{icon}</div>
                      <p className="landing-audience-role__text">{text}</p>
                    </article>
                  ))}
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>

      <section
        id="why"
        className="landing-band landing-band--why landing-section landing-section--benefits"
      >
        <div className="landing-container">
          <LandingSectionHeader
            label="04 · Преимущества"
            title="Почему это лучше классических инструкций и скучных видео"
            desc="Бумажные должностные инструкции лежат без дела, PDF никто не читает, а длинные записи перематывают. MOGAME даёт живое обучение, подсказки и проверку знаний там, где команда уже каждый день — в мессенджере."
          />
          <div className="landing-band__panel landing-band__panel--why">
            <div className="landing-benefits landing-benefits--five">
              {BENEFITS.map(({ icon, title, desc }) => (
                <article className="landing-benefit-card" key={title}>
                  <div className="landing-benefit-card__icon">{icon}</div>
                  <h3 className="landing-benefit-card__title">{title}</h3>
                  <p className="landing-benefit-card__desc">{desc}</p>
                </article>
              ))}
            </div>
            <div className="landing-outcomes">
              {OUTCOMES.map(({ icon, title, desc }) => (
                <article className="landing-outcome-card" key={title}>
                  <div className="landing-outcome-card__icon">{icon}</div>
                  <div>
                    <h3 className="landing-outcome-card__title">{title}</h3>
                    <p className="landing-outcome-card__desc">{desc}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      <LandingMotivationSection />

      <LandingCreationSection />

      <section
        id="launch"
        className="landing-band landing-band--launch landing-section landing-section--steps"
      >
        <div className="landing-container">
          <LandingSectionHeader
            label="09 · Запуск"
            title="Четыре шага до запуска в мессенджере"
            desc="От выбора инструмента до доступа для команды — база знаний, сценарий или тренажёр, без программистов и сложных интеграций"
          />
          <div className="landing-band__panel landing-band__panel--launch">
            <div className="landing-launch landing-launch--timeline-only">
            <div className="landing-launch__timeline">
              <CustomizedTimeline />
            </div>
            <aside className="landing-launch__aside">
              <div className="landing-launch__highlights">
                <div className="landing-intro__highlight">
                  <strong>Три инструмента</strong> — база знаний, сценарий, тренажёр
                </div>
                <div className="landing-intro__highlight landing-intro__highlight--messengers">
                  <span className="landing-intro__highlight-text">
                    <strong>Telegram или MAX</strong> — прохождение там, где люди
                    уже каждый день
                  </span>
                  <MessengerBrandStack size={30} />
                </div>
                <div className="landing-intro__highlight">
                  <strong>Без лишней возни</strong> — редактор, контент, ссылка
                  для команды, запуск
                </div>
              </div>
            </aside>
            </div>
          </div>
        </div>
      </section>

      <LandingAnalyticsSection />

      <section
        id="cases"
        className="landing-band landing-band--cases landing-section landing-section--usecases"
      >
        <div className="landing-container">
          <LandingSectionHeader
            label="11 · Истории"
            title="Как инструменты MOGAME помогают в реальной работе"
            desc="Ситуации из разных отраслей — когда база знаний, сценарий или тренажёр решают конкретную задачу команды"
          />
          <div className="landing-band__panel landing-band__panel--cases">
            <div className="landing-stories">
            {STORIES.map(({ segment, tool, story, result }) => (
              <article className="landing-story-card" key={segment}>
                <div className="landing-story-card__meta">
                  <span className="landing-story-card__segment">{segment}</span>
                  <span className="landing-story-card__tool">{tool}</span>
                </div>
                <blockquote className="landing-story-card__quote">{story}</blockquote>
                <p className="landing-story-card__result">{result}</p>
              </article>
            ))}
            </div>
          </div>
        </div>
      </section>

      <section className="landing-cta">
        <h2 className="landing-cta__title">
          Запустите обучение, базу знаний или тренажёр для команды
        </h2>
        <div className="landing-cta__messengers">
          <MessengerBrandInline size={36} spaced />
        </div>
        <p className="landing-cta__desc">
          Создайте проект, оформите подписку и отправьте ссылку — команда получит
          обучение, подсказки и проверку знаний в Telegram или MAX.
        </p>
        <div className="landing-cta__actions">
          <Link to="/login?tab=register">
            <Button
              variant="contained"
              size="large"
              className="landing-hero__btn-primary"
            >
              Начать
            </Button>
          </Link>
          <Link to="/login">
            <Button
              variant="outlined"
              size="large"
              className="landing-hero__btn-secondary"
            >
              Уже есть аккаунт — войти
            </Button>
          </Link>
        </div>
      </section>

      <section
        id="faq"
        className="landing-band landing-band--faq landing-faq landing-section--faq"
      >
        <div className="landing-container">
          <LandingSectionHeader
            label="12 · Вопрос-ответ"
            title="Частые вопросы"
            desc="О платформе, подписке и запуске программ для команд"
          />
          <div className="landing-band__panel landing-band__panel--faq">
            <AccordionComponent />
          </div>
        </div>
      </section>

      <div className="footer">
        <div>
          <a
            href="/oferta"
            target="_blank"
            rel="noreferrer"
            style={{ color: "white" }}
          >
            Оферта
          </a>
        </div>
      </div>
    </div>
  );
}
